import React,{useState} from 'react';
import { Typewriter,Cursor } from 'react-simple-typewriter';
import '../styles/popup.css'
const Popup = ()=>{
    const [display,setDisplay] = useState(false)
    const str = `Welcome to my personal portfolio! My name is Mohamed, and I am a web developer with expertise in network and telecommunications and a passion for artificial intelligence. With a commitment to innovation and problem-solving, I am dedicated to creating visually stunning, user-friendly websites that meet the needs of my clients.
    As a web developer, I have experience designing and building responsive websites using various programming languages and frameworks.
    In addition to my web development skills, I have a deep interest in artificial intelligence. I have developed my own AI projects that have been used to enhance efficiency and productivity. I am constantly exploring new applications for AI and finding ways to integrate it into my web development work.
    This portfolio showcases my work in web development, and artificial intelligence, as well as my background and experience. Thank you for taking the time to visit my portfolio, and I look forward to the opportunity to work with you on your next project!`
    
    const animationend = ()=>{
        setDisplay(true)
    }
          return(
          <div className='popup'>
                <div className='circle ui-shadow'>
                    <div className='middle-circle'>
                        </div>
                    </div>
                <div className='first-line ui-shadow'></div>
                <div className='second-line ui-shadow'></div>
                <div className='label-container'>
                    <div onAnimationEnd={animationend} className='label'>
                    <p>
                    { display && <Typewriter words={[str]} loop={1}  typeSpeed={20}/>}
                    </p>
                        
                    </div>
                </div>
                </div>
          )
}
export default Popup;